import React from 'react';
import { Eye, Edit2, MessageSquare } from 'lucide-react';
import { ProjectCase } from '../../../types';
import Badge from '../../../components/ui/Badge';
import { caseStatusVariant, casePriorityVariant } from '../../../utils/badgeVariants';

export const CASE_COLUMNS = (
  onView: (id: number) => void,
  onEdit: (id: number) => void,
  onComments: (id: number) => void,
) => [
  {
    id: 'case_number',
    label: 'Case #',
    accessor: 'case_number',
    render: (c: ProjectCase) => (
      <span style={{ fontSize: 13, fontFamily: 'monospace', color: 'var(--text-secondary)' }}>{c.case_number}</span>
    ),
  },
  {
    id: 'case_subject',
    label: 'Subject',
    accessor: 'case_subject',
    render: (c: ProjectCase) => (
      <span style={{ fontSize: 13, color: 'var(--text-primary)' }}>{c.case_subject}</span>
    ),
  },
  {
    id: 'project',
    label: 'Project',
    accessor: 'project',
    render: (c: ProjectCase) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.project?.name || '-'}</span>
    ),
  },
  {
    id: 'case_status',
    label: 'Status',
    accessor: 'case_status',
    render: (c: ProjectCase) => (
      <Badge variant={caseStatusVariant(c.case_status)}>
        {c.case_status.replace('_', ' ')}
      </Badge>
    ),
  },
  {
    id: 'case_priority',
    label: 'Priority',
    accessor: 'case_priority',
    render: (c: ProjectCase) => (
      <Badge variant={casePriorityVariant(c.case_priority)}>
        {c.case_priority}
      </Badge>
    ),
  },
  {
    id: 'assigned',
    label: 'Assigned',
    accessor: 'assigned',
    render: (c: ProjectCase) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.assignedTeam?.name || '-'}</span>
    ),
  },
  {
    id: 'due_date',
    label: 'Due Date',
    accessor: 'due_date',
    render: (c: ProjectCase) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>
        {c.due_date ? new Date(c.due_date).toLocaleDateString() : '-'}
      </span>
    ),
  },
  {
    id: 'type',
    label: 'Type',
    accessor: 'type',
    render: (c: ProjectCase) => (
      <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{c.type}</span>
    ),
  },
  {
    id: 'actions',
    label: 'Actions',
    accessor: 'actions',
    render: (c: ProjectCase) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button
          onClick={(e) => { e.stopPropagation(); onView(c.id); }}
          title="View"
          style={{ padding: '6px', color: '#2563eb', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(37,99,235,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Eye style={{ width: 14, height: 14 }} />
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); onEdit(c.id); }}
          title="Edit"
          style={{ padding: '6px', color: '#7c3aed', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(124,58,237,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <Edit2 style={{ width: 14, height: 14 }} />
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); onComments(c.id); }}
          title="Comments"
          style={{ padding: '6px', color: '#16a34a', background: 'transparent', border: 'none', borderRadius: 6, cursor: 'pointer' }}
          onMouseEnter={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'rgba(22,163,74,0.1)')}
          onMouseLeave={(e) => ((e.currentTarget as HTMLButtonElement).style.background = 'transparent')}
        >
          <MessageSquare style={{ width: 14, height: 14 }} />
        </button>
      </div>
    ),
  },
];
